export class NamedObject {
  constructor(name) {
    this.name = name;
  }

  forEach(/*action*/) {}  // eslint-disable-line

  recursiveExecute(/*funcName, ...args*/) {}
}

export class SingleNamedObject extends NamedObject {
  constructor(name, item) {
    super(name);
    this.item = item; // item is some object
  }

  forEach(action) {
    action(this.item, this.name);
  }

  recursiveExecute(funcName, ...args) {
    this.item[funcName]?.(...args);
  }
}

export class NamedObjectContainer extends NamedObject {
  constructor(name) {
    super(name);
    this.items = []; // each item is NamedObject
  }

  forEach(action) {
    for (let i = 0; i < this.items.length; i++) {
      this.items[i].forEach(action);
    }
  }

  forEachChild(action) {
    for (let i = 0; i < this.items.length; i++) {
      action(this.items[i]);
    }
  }

  recursiveExecute(funcName, ...args) {
    for (let i = 0; i < this.items.length; i++) {
      this.items[i].recursiveExecute(funcName, ...args);
    }
  }

  add(item) {
    this.items.push(item);
  }

  addUnique(item) {
    let index = this.findIndex(item.name);
    if (index < 0) {
      this.items.push(item);
    } else {
      this.items[index] = item;
    }
  }

  insert(index, item) {
    if (index < 0) {
      index = 0;
    } else if (index > this.items.length) {
      index = this.items.length;
    }
    this.items.splice(index, 0, item);
  }

  update(itemName, itemValue) {
    let index = this.findIndex(itemName);
    if (index < 0) {
      return;
    }
    this.items[index].item = itemValue;
  }

  removeWithoutCheck(index) {
    this.items.splice(index, 1);
  }

  remove(index) {
    if (index >= 0 && index < this.items.length) {
      this.items.splice(index, 1);
    }
  }

  removeByName(name) {
    let index = this.findIndex(name);
    if (index >= 0) {
      this.items.splice(index, 1);
    }
  }

  clear() {
    this.items = [];
  }

  findIndex(name) {
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].name == name) {
        return i;
      }
    }
    return -1;
  }

  findItem(name) {
    let index = this.findIndex(name);
    if (index < 0) {
      return undefined;
    }
    return this.items[index];
  }

  getItem(index) {
    if (index < 0 || index >= this.items.length) {
      return undefined;
    }
    return this.items[index];
  }
}
